import { MenuClass } from '@/apis/menu'
import { RoleClass } from '@/apis/role'
import { UserClass, DepartmentClass } from '@/apis/user'

import { GoodsCategoryClass, OrderClass } from '@/apis/goods'
import { NewsTypeClass } from '@/apis/news'

const role = new RoleClass()
const menu = new MenuClass()
const user = new UserClass()
const department = new DepartmentClass()
const order = new OrderClass()

const category = new GoodsCategoryClass()
const newsType = new NewsTypeClass()

const data = {
  state: {
    ALL_MENUS: [],
    ALL_RULES: [],
    ALL_ROLES: [],
    ALL_SALES: [],
    ALL_ALIPAYQRCODE: [],

    ALL_GOODSCATEGORYS: [],
    ALL_NEWTYPES: [],
    ALL_DEPARTMENTS: [],
    LAST_ORDER_NUM: ''
  },
  mutations: {
    SET_DATA_MENUS (state, value) {
      state.ALL_MENUS = value
    },
    SET_DATA_ROLES (state, value) {
      state.ALL_ROLES = value
    },
    SET_DATA_RULES (state, value) {
      state.ALL_RULES = value
    },
    SET_DATA_SALES (state, value) {
      state.ALL_SALES = value
    },
    SET_DATA_ALIPAYQRCODES (state, value) {
      state.ALL_ALIPAYQRCODE = value
    },

    SET_DATA_GOODSCATEGORYS (state, value) {
      state.ALL_GOODSCATEGORYS = value
    },

    SET_DATA_NEWTYPES (state, value) {
      state.ALL_NEWTYPES = value
    },

    SET_DATA_DEPARTMENTS (state, value) {
      state.ALL_DEPARTMENTS = value
    },

    SET_LAST_ORDER_NUM (state, value) {
      state.LAST_ORDER_NUM = value
    }
  },
  actions: {
    // 权限菜单
    GetMenuData ({ commit }, roleId) {
      return new Promise((resolve, reject) => {
        menu.gets({ roleId, Limit: 99999 }).then(resp => {
          commit('SET_DATA_MENUS', resp.data)
          resolve(resp.data)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    // 全部角色
    GetAllRoles ({ commit }) {
      return new Promise((resolve, reject) => {
        role.all().then(resp => {
          commit('SET_DATA_ROLES', resp)
          resolve(resp)
        }).catch(() => {
          reject(new Error('获取角色失败 !'))
        })
      })
    },

    // 全部销售
    GetAllSales ({ commit }) {
      return new Promise((resolve, reject) => {
        user.gets({ Limit: 999, RoleIds: [2, 3] }).then(resp => {
          commit('SET_DATA_SALES', resp.data)
          resolve(resp.data)
        }).catch(() => {
          reject(new Error('获取销售失败 !'))
        })
      })
    },

    // 全部权限
    GetAllRules ({ commit }) {
      return new Promise((resolve, reject) => {
        menu.gets({ Limit: 99999 }).then(resp => {
          commit('SET_DATA_RULES', resp.data)
          resolve(resp.data)
        }).catch(() => {
          reject(new Error('获取权限失败 !'))
        })
      })
    },

    // 全部商品分类
    GetAllGoodsCategorys ({ commit }) {
      return new Promise((resolve, reject) => {
        category.gets({ Limit: 9999 }).then(resp => {
          commit('SET_DATA_GOODSCATEGORYS', resp.data)
          resolve(resp.data)
        }).catch(() => {
          reject(new Error('获取商品分类失败 !'))
        })
      })
    },

    // 全部文章分类
    GetAllNewsTypes ({ commit }) {
      return new Promise((resolve, reject) => {
        newsType.gets({ Limit: 9999 }).then(resp => {
          commit('SET_DATA_NEWTYPES', resp.data)
          resolve(resp.data)
        }).catch(() => {
          reject(new Error('获取文章分类失败 !'))
        })
      })
    },

    // 全部区域
    GetAllDepartment ({ commit }) {
      return new Promise((resolve, reject) => {
        department.gets().then(resp => {
          commit('SET_DATA_DEPARTMENTS', resp)
          resolve(resp)
        }).catch(() => {
          reject(new Error('获取区域失败 !'))
        })
      })
    },

    // 获取最新订单
    GetLastOrder ({ commit }) {
      return new Promise((resolve, reject) => {
        order.getLastOrder().then(resp => {
          if (resp) {
            resolve(resp.orderNo)
          }
        })
      })
    }
  }
}

export default data
